import { normalize } from "normalizr";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    LIKE_INFO_FETCH_TRIGGER,
    LikeInfoFetchNormalizedResponse,
    LikeInfoFetchTriggerAction,
    likeInfoFetchApi,
} from "@/mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.actions";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { UserEntity, UserSchema } from "@/mk2/schemas";
import { like_api_likers_url } from "@/mk/urls/functions";

const logger = getLogger("blogs/LikeInfoPopup.sagas");

interface ApiResponseCommentLikers {
    body: {
        likers: UserEntity[];
    };
}

function* fetchCommentLikers({
    entityType,
    entityId,
    linkAccessKey,
    xhr,
}: LikeInfoFetchTriggerAction & XHRAction) {
    yield put(likeInfoFetchApi.request(entityType, entityId));

    try {
        const response: ApiResponseCommentLikers = yield call(() =>
            xhr.get(like_api_likers_url(), { entityType, entityId, linkAccessKey }),
        );
        const normalizedResponse: LikeInfoFetchNormalizedResponse = normalize(response.body, {
            likers: [UserSchema],
        });

        yield put(likeInfoFetchApi.success(entityType, entityId, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(likeInfoFetchApi.failure(entityType, entityId, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(LIKE_INFO_FETCH_TRIGGER, fetchCommentLikers)]);
}
